import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSession } from '@cordata/buffet';
import { usePatient } from '~/utils';

import { Accordian, PageLayout } from '~/components';
import { hasFullPatientIdentityAccess } from '~/utils/patient/identity-access';

import AbuseNote from './abuse-note';

const Reports = () => {
  const [, patient] = usePatient();
  const { current } = useSession();

  if (!hasFullPatientIdentityAccess(patient, current?.attributes?.accessibleDivisions)) {
    return <Redirect to={`/patients/${patient.id}`} />;
  }

  return (
    <PageLayout title="Reports">
      <Accordian
        items={[{
          title: 'Hospital Child Abuse and Neglect',
          body: <AbuseNote />,
        }]}
      />
    </PageLayout>
  );
};

export default Reports;
